import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import ApiProjectedCashFlow from '../../Api/ApiProjectedCashFlow';
import ToastMsg from '../../Components/ToastMsg';
import { creators as ProjectedCashFlowActions } from '../../Reducers/Reporting/ProjectedCashFlow';

export function* getPCFTopData({ payload }) {
  try {
    const response = yield call(
      ApiProjectedCashFlow.getTop,
      payload.selectedYears,
      payload.DateKey,
      payload.ReportingDateKey,
    );

    if (response.status === 200) {
      yield put(
        ProjectedCashFlowActions.projectedcashflowSuccess({ topData: response.data }),
      );
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Projected Cash Flow Top Data',
            text: response.message,
          },
        },
      );
      yield put(ProjectedCashFlowActions.projectedcashflowFailure(response.message));
    }
  } catch (e) {
    yield put(ProjectedCashFlowActions.projectedcashflowFailure(e));
  }
}

export function* getPCFMiddleData({ payload }) {
  try {
    const response = yield call(
      ApiProjectedCashFlow.getMiddle,
      payload.selectedYears,
      payload.DateKey,
      payload.ReportingDateKey,
    );

    if (response.status === 200) {
      yield put(
        ProjectedCashFlowActions.projectedcashflowSuccess({
          middleData: response.data,
        }),
      );
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Projected Cash Flow Middle Data',
            text: response.message,
          },
        },
      );
      yield put(ProjectedCashFlowActions.projectedcashflowFailure(response.message));
    }
  } catch (e) {
    yield put(ProjectedCashFlowActions.projectedcashflowFailure(e));
  }
}

export function* getPCFBottomData({ payload }) {
  try {
    const response = yield call(
      ApiProjectedCashFlow.getBottom,
      payload.selectedYears,
    );

    if (response.status === 200) {
      yield put(
        ProjectedCashFlowActions.projectedcashflowSuccess({
          bottomData: response.data,
        }),
      );
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Projected Cash Flow Bottom Data',
            text: response.message,
          },
        },
      );
      yield put(ProjectedCashFlowActions.projectedcashflowFailure(response.message));
    }
  } catch (e) {
    yield put(ProjectedCashFlowActions.projectedcashflowFailure(e));
  }
}
